import {addRoutes} from '../router/index.js'
import {addI18n} from '../lang/index.js'
import {addMenuViewMap} from '../router/menuViewMap.js'
import service from './request';
import show from '@/components/show';
import scss from '@/assets/scss/index';
import setting from '@/settings';

export default (context) => {
    context.Vue.prototype.$addRoutes = addRoutes;
    context.Vue.prototype.$addMenuViewMap = addMenuViewMap;
    context.Vue.prototype.$addI18n = addI18n;
    context.Vue.prototype.$service = {}; // 注册$service
    context.Vue.prototype.$http = service;
    context.Vue.prototype.$show = show ;
    context.Vue.prototype.$scss = scss ;
    context.Vue.prototype.$setting = setting ;
}